import {
  IMyOpenRolesResponseData,
  IRequisition,
} from 'modules/hiring/models/myOpenRequisition.model';

export interface IMyOpenRolesState {
  data: IMyOpenRolesResponseData | null;
  error: string;
  isFetching: boolean;
}

export const MY_OPEN_ROLES_INITIAL_STATE: IMyOpenRolesState = {
  data: null,
  error: '',
  isFetching: false,
};

export type TSelectedOpenRequisitionState = IRequisition | null;
